export default {
  computed: {
    isEditableInEE() {
      return this.$jss.sitecoreContext().pageEditing
    }
  }
}
